import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const UnlockMasterSlice = createSlice({
  name: "UnlockMaster",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    unlockMaster: (state, _) => {
      state.isLoading = true;
    },
    successUnlockMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUnlockMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearUnlockMaster: (state) => {
      state.data = {};
    },
  },
});

export const {
  unlockMaster,
  failureUnlockMaster,
  successUnlockMaster,
  clearUnlockMaster,
} = UnlockMasterSlice.actions;

export default UnlockMasterSlice.reducer;
